import { Underlined } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const getFileUploaderCopy = translate => ({
  BROWSE_FILES: translate('FileUploader.browseFiles'),
  DRAG_N_DROP: disabled => translate('FileUploader.dragAndDrop', str => jsx(Underlined, {
    color: disabled && 'inherit',
    as: "span",
    children: str
  })),
  MAX_SIZE: maxSize => translate('FileUploader.maxSize', maxSize),
  EXISTS: fileName => translate('FileUploader.fileExists', fileName),
  MAX_FILES: maxAmount => translate('FileUploader.maxFilesReached', maxAmount),
  MAX_POLICY_SIZE: translate('FileUploader.maxPolicySize'),
  NO_FILES: translate('FileUploader.noFilesUploaded'),
  CANCELLED: translate('FileUploader.uploadCancelled'),
  FAILED: translate('FileUploader.uploadFailed'),
  ARIA_LABELS: {
    CLOSE: translate('FileUploader.cancelUpload'),
    REMOVE: translate('FileUploader.removeFile'),
    RETRY: translate('FileUploader.retryUpload')
  }
});

export { getFileUploaderCopy };
